import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("mbg_token");
        if (!token) { setLoading(false); return; }
        api.get("/auth/me").then(r => setUser(r.data)).catch(() => localStorage.removeItem("mbg_token")).finally(() => setLoading(false));
    }, []);

    const login = useCallback(async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("mbg_token", data.token);
        setUser(data.user);
        return data.user;
    }, []);
    const register = useCallback(async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        localStorage.setItem("mbg_token", data.token);
        setUser(data.user);
        return data.user;
    }, []);
    const logout = useCallback(() => { localStorage.removeItem("mbg_token"); setUser(null); }, []);

    const isAdmin = user?.role === "admin";
    const isB2B = user?.is_b2b && user?.b2b_status === "approved";

    const value = useMemo(
        () => ({ user, loading, login, register, logout, isAdmin, isB2B, setUser }),
        [user, loading, login, register, logout, isAdmin, isB2B]
    );

    return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}
